import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  customTableCell: {
    color: `${theme.palette.text.primary}`,
    borderBottom: `1px solid rgba(211, 211, 211,0.3)`,
    padding: "5px !important",
    width: "190px",
    fontSize: {
      xs: "8px !important",
      sm: "10px !important",
      md: "10px !important",
      lg: "12px !important",
      xl: "14px !important",
    },
  },

  select: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "5px !important",
    width: "100%",
    height: "35px",
    color: "white !important",
    cursor: "pointer",
    "& .MuiSelect-icon": {
      color: "white !important",
    },
    "& .MuiSelect-nativeInput": {
      padding: "4px 10px !important",
    },
  },
  selectMenuItem: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
    color: "white !important",
  },
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chip: {
    fontSize: "14px",
    minWidth: "20px",
    cursor: "pointer",
  },
}));

export default useStyles;
